module.exports = __webpack_public_path__ + "assets/unix.f4de1bf8.svg";